const coverObject = (originalObject, object) => {
  const keyList = Object.keys(originalObject);
  keyList.forEach(key => {
    if (object[key]) {
      originalObject[key] = object[key];
    }
  });
  return originalObject;
};

/**
 * 將「回傳 Promise 的函式陣列」按上限 (limit) 併發執行。
 * @param {Function[]} tasks 每個元素都是 () => Promise
 * @param {number} limit 同時允許的最大併發數
 * @returns {Promise<unknown[]>} 依原順序回傳結果
 */
async function runQueue(tasks, limit = 5) {
  const results = new Array(tasks.length);
  let nextIndex = 0;                        // 下一個要執行的任務索引

  // 啟動 limit 個 worker
  const workers = Array.from({ length: Math.min(limit, tasks.length) }, async () => {
    while (nextIndex < tasks.length) {
      const current = nextIndex++;          // 取得當前要跑的索引
      try {
        results[current] = await tasks[current]();
      } catch (err) {                       // 把錯誤也記下來，方便後續處理
        results[current] = Promise.reject(err);
      }
    }
  });

  await Promise.all(workers);               // 等所有 worker 跑完
  return results;
}


export { coverObject, runQueue };
